@if ($model() != null) {
    <form class="px-1" (ngSubmit)="onSubmit()" #extraContent="ngForm">
        <div class="scroll-wrapper styled-scrollbar px-2">
            @if ($shouldShowEnableExtraContent()) {
                <!-- Habilitar o conteúdo extra -->
                <div class="form-group use-extra-content ml-0 mb-4"
                     featureHint="flowObjectDetailsExtraContent|EnableExtraContent" featureHintHAlign="right" featureHintShowOn="right"
                >
                    <mat-checkbox class="custom-css" id="enableExtraContent" name="enableExtraContent" color="primary"
                                  [ngModel]="$enableExtraContent()"
                                  [disabled]="$isReadOnlyMode()"
                                  (change)="onEnableExtraContentChange($event.checked)"
                    >Habilitar o uso de conteúdo extra nesta Tarefa</mat-checkbox>
                </div>
            }

            @if (!$shouldShowEnableExtraContent()) {
                <!-- Mesagem de espera para o requerente -->
                <div class="form-group waiting-message-container ml-0 mb-4" [class.mandatory]="$forgotWaitingMessage() && $waitingMessageLength() < 10"
                     featureHint="flowObjectDetailsExtraContent|WaitingMessage" featureHintHAlign="right" featureHintVAlign="top" featureHintShowOn="right"
                >
                    <span>Mensagem ao usuário enquanto aguarda a conclusão da Tarefa</span>

                    <!-- Mensagem de espera -->
                    <div class="form-group mt-2">
                        <editor name="waitingMessage" apiKey="no-api-key"
                                [ngModel]="$waitingMessage()"
                                [disabled]="$disableFields()"
                                [init]="$tinyMceOptionsWaitingMessage()"
                                (ngModelChange)="$waitingMessage.set($event)"
                        ></editor>

                        <textarea id="tinyMceExtraContentWaitingMessage" class="d-none"></textarea>
                    </div>
                </div>
            }

            <!-- Tipo de conteúdo -->
            <div class="form-group content-type-container ml-0 mb-3">
                <span>Selecione o tipo de conteúdo que será fornecido pelo servidor responsável no momento da execução da Tarefa:</span>

                <mat-radio-group class="my-2" id="contentType" name="contentType" color="primary"
                                 [ngModel]="$contentType()"
                                 [disabled]="$disableFields()"
                                 (ngModelChange)="$contentType.set($event)"
                >
                    @if (!$shouldShowEnableExtraContent()) {
                        <!-- Texto -->
                        <mat-radio-button [value]="ExtraContentType.Text">Texto</mat-radio-button>
                    }

                    <!-- Anexos -->
                    <mat-radio-button [value]="ExtraContentType.Attachment">Anexos</mat-radio-button>
                </mat-radio-group>

                <!-- Configuração do documento capturado a partir da mensagem fornecida -->
                @if ($contentType() == ExtraContentType.Text && !$shouldShowEnableExtraContent()) {
                    <div class="text-content-type-container mt-3"
                         featureHint="flowObjectDetailsExtraContent|Text" featureHintHAlign="right" featureHintVAlign="top" featureHintShowOn="right"
                    >
                        <!-- Mensagem pré-configurada -->
                        <div class="form-group content-type-text-row px-3 mt-3">
                            <label for="message">Mensagem pré-configurada</label>

                            <editor name="message" apiKey="no-api-key"
                                    [ngModel]="$message()"
                                    [init]="$tinyMceOptionsMessage()"
                                    [disabled]="$disableFields()"
                                    (ngModelChange)="$message.set($event)"
                            ></editor>

                            <textarea id="tinyMceExtraContentMessage" class="d-none"></textarea>
                        </div>

                        <!-- Classificação Documental -->
                        <div class="content-type-text-row px-3">
                            <div class="form-group">
                                <h5>
                                    <span>Classificação Documental</span>
                                </h5>
                            </div>

                            <document-class [_model]="$documentClass()"
                                            [_flowDefinitionOrganizationId]="$flowDefinition().organizationId"
                                            [_isReadOnlyMode]="$disableFields()"
                                            (_modelChange)="onUpdateDocumentClass($event)"
                            ></document-class>
                        </div>

                        <!-- Nível de Acesso -->
                        <div class="content-type-text-row px-3">
                            <div class="form-group">
                                <h5>
                                    <span>Nível de Acesso do Documento</span>
                                </h5>
                            </div>

                            <access-level [_model]="$accessLevel()"
                                            [_flowDefinitionOrganizationId]="$flowDefinition().organizationId"
                                            [_isReadOnlyMode]="$disableFields()"
                                            (_modelChange)="onUpdateAccessLevel($event)"
                            ></access-level>
                        </div>
                    </div>
                }

                <!-- Configuração dos anexos -->
                @if (
                    $contentType() == ExtraContentType.Attachment
                    && (
                        ($shouldShowEnableExtraContent() && $enableExtraContent())
                        || !$shouldShowEnableExtraContent()
                    )
                ) {
                    <div class="attachment-content-type-container mb-2"
                         featureHint="flowObjectDetailsExtraContent|Attachment" featureHintHAlign="right" featureHintVAlign="top" featureHintShowOn="right"
                    >
                        @for (item of $attachments(); track item; let i = $index) {
                            <div class="attachment-container p-3 mt-3">
                                @if (!$disableFields()) {
                                    <!-- Remover Anexo -->
                                    <button type="button" class="btn btn-outline-danger remove" matTooltip="Remover este anexo" (click)="removeAttachment(item)">
                                        <i class="fas fa-trash mr-2"></i>
                                        <span>Remover</span>
                                    </button>
                                }

                                <!-- Nome do Anexo -->
                                <ng-container>
                                    <div class="form-group">
                                        <label for="label_{{i}}">Nome do Anexo</label>
                                        <input type="text" class="form-control" #labelElem="ngModel" maxlength="100" required
                                                id="label_{{i}}"
                                                name="label_{{i}}"
                                                [disabled]="$disableFields()"
                                                [(ngModel)]="item.label"
                                        >
                                    </div>
                                    <div [hidden]="labelElem.valid || labelElem.pristine" class="alert alert-danger">Campo obrigatório</div>

                                    @if (Utils.isNotNullOrEmpty(item.label)) {
                                        <blockquote class="info-container field attachment-label mb-3">
                                            <div class="description info-highlight">
                                                <i class="fas fa-info-circle info"></i>
                                                <span>
                                                    Com as configurações atuais, o nome final deste anexo quando capturado no E-Docs será:
                                                    <br />
                                                    <span class="code-font text-highlight">
                                                        {{getFinalDocumentNamePreview(item.label)}}
                                                    </span>
                                                </span>
                                            </div>
                                        </blockquote>
                                    }
                                </ng-container>

                                <!-- Valor Legal do Documento para Conferência -->
                                <ng-container>
                                    <div class="form-group"
                                         featureHint="flowObjectDetailsExtraContent|DocumentLegalValue" featureHintHAlign="right" featureHintShowOn="right"
                                    >
                                        <label for="dlvc_{{i}}">Valor Legal do Documento para Conferência</label>

                                        <select class="form-control px-1" id="dlvc_{{i}}" name="dlvc_{{i}}" #dlvcElem="ngModel" required
                                                [disabled]="$disableFields()"
                                                [(ngModel)]="item.documentLegalValueCombination"
                                        >
                                            @for (option of documentLegalValueCombinationOptions; track option) {
                                                <option [value]="option.value">{{option.description}}</option>
                                            }
                                        </select>

                                        <div [hidden]="dlvcElem.valid || dlvcElem.pristine" class="alert alert-danger">Campo obrigatório</div>
                                    </div>
                                </ng-container>

                                <!-- Classificação Documental -->
                                <ng-container>
                                    <div class="form-group mt-4">
                                        <h5>
                                            <span>Classificação Documental</span>
                                        </h5>
                                    </div>

                                    <document-class [_model]="item.documentClass"
                                                    [_flowDefinitionOrganizationId]="$flowDefinition().organizationId"
                                                    [_isReadOnlyMode]="$disableFields()"
                                                    (_modelChange)="onUpdateDocumentClass($event, item)"
                                    ></document-class>
                                </ng-container>

                                <!-- Nível de Acesso -->
                                <ng-container>
                                    <div class="form-group mt-4">
                                        <h5>
                                            <span>Nível de Acesso do Documento</span>
                                        </h5>
                                    </div>

                                    <access-level #accessLevelRef
                                                    [_model]="item.accessLevel"
                                                    [_flowDefinitionOrganizationId]="$flowDefinition().organizationId"
                                                    [_isReadOnlyMode]="$disableFields()"
                                                    (_modelChange)="onUpdateAccessLevel($event, item)"
                                    ></access-level>
                                </ng-container>
                            </div>
                        }

                        <!-- Adicionar Anexo -->
                        @if ($canAddAttachment() && !$disableFields()) {
                            <div class="d-flex justify-content-center mt-3">
                                <button type="button" class="btn btn-outline-success add" (click)="addAttachment()">
                                    <i class="fas fa-plus mr-2"></i>
                                    <span>Adicionar Anexo</span>
                                </button>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>

        <!-- Botões -->
        <div class="form-footer text-right mb-1">
            <hr class="mt-0" />

            <!-- ConfigSchema -->
            <div class="button-wrapper float-left ml-1" featureHint="flowObjectDetails|ConfigSchemaButton" featureHintVAlign="bottom" featureHintShowOn="right">
                <button type="button" class="btn btn-outline-secondary" (click)="showConfigSchema()">Editar código-fonte</button>
            </div>

            <!-- Cancelar -->
            <div class="button-wrapper mr-2" featureHint="flowObjectDetails|CancelButton" featureHintVAlign="bottom" featureHintShowOn="right">
                <button type="button" class="btn btn-outline-danger" (click)="closeForm()">Cancelar</button>
            </div>

            <!-- Salvar -->
            <div class="button-wrapper" featureHint="flowObjectDetails|SaveButton" featureHintVAlign="bottom" featureHintShowOn="right">
                <button type="submit" class="btn btn-outline-primary"
                        [disabled]="!extraContent.form.valid || $isReadOnlyMode()"
                >Salvar Rascunho</button>
            </div>
        </div>
    </form>

    <!-- Modal do ConfigSchema -->
    <ng-template #configSchemaRef>
        <i class="button fas fa-times close" matTooltip="Fechar" (click)="configSchemaDialog.close()"></i>

        <button type="button" class="button btn btn-primary" (click)="Utils.copyToClipboard(configSchemaEditorRef, copyInfoRef);">
            <i class="fas fa-copy mr-2"></i>
            <span>Copiar conteúdo</span>
        </button>

        <button type="button" class="button btn btn-outline-info info" #copyInfoRef><span>Conteúdo copiado!</span></button>
        <button type="button" class="button btn btn-outline-info info" #pasteInfoRef><span>Conteúdo colado!</span></button>

        <button type="button" class="button btn btn-success right" (click)="Utils.pasteFromClipboard(configSchemaEditorRef, pasteInfoRef)">
            <i class="fas fa-paste mr-2"></i>
            <span>Colar conteúdo</span>
        </button>

        <textarea class="schema-editor form-control styled-scrollbar" [ngModel]="$configSchemaFlat()" #configSchemaEditorRef></textarea>
    </ng-template>
}
